<template lang="pug">
  div#placeholder-empty
    p#title Empty Questions List
</template>

<script>
  export default {
    name: 'EmptyPlaceholder',

    data () {
      return {
        info: 'Please load this page from the Canvas app.',
      }
    },

    mounted() {
      this.$emit('onProcessing', false)
    },
  } 
</script>

<style module>
  #questionlist {
    width: 100%;
    margin: auto;
  }

  #placeholder-empty {
    padding: 100px; 
    width: parent; 
    text-align: center; 
    border: 5px solid #DCDFE6; 
    border-style: dashed;
    margin: 2%;
  }

  #title {
    font-size: 20px;
    color: #C0C4CC;
  }
</style>
